import { Grid, Paper, Stack } from "@mui/material";
import React from "react";
import { useStore } from "utils/useStore";
import { LLMClassifierBuilderStore } from "components/Classifiers/LLMClassifiers/Stores/LLMClassifierBuilderStore";
import { GoToConversation } from "../GoToConversation";
import { LLMExecutionResultInformation } from "../LLMExecutionResultInformation";
import { TestedConversationDetails } from "../TestedConversationDetails";
import { ViewTranscript } from "../ViewTranscript";
import { TestLLMClassifierOnConversationResult } from "models/LLMs/Testing/TestLLMClassifierOnConversationResult";

interface MetadataResultCardProps {
    result: TestLLMClassifierOnConversationResult;
    number: number;
}

export function MetadataResultCard({
    result,
    number,
}: MetadataResultCardProps) {
    const store = useStore(LLMClassifierBuilderStore);

    const writtenMetadata = Object.entries(
        result.executionResult?.extendedMetadataToWrite ?? {},
    ).map(([key, value]) => ({
        classifier: store.allExtendedMetadata.find((c) => c.id === key),
        value: value.value,
    }));

    return (
        <Paper
            sx={(theme) => ({
                borderRadius: theme.shape.borderRadius / 2,
                boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.07)",
                border: `1px solid ${theme.palette.lightgrayBorder.main}`,
                padding: 2,
            })}
        >
            <Stack rowGap={2}>
                <TestedConversationDetails
                    conversation={result.conversation}
                    number={number}
                    wouldExecuteUnderConditions={
                        result.wouldExecuteUnderConditions
                    }
                    writtenMetadata={writtenMetadata}
                />
                {result.executionResult && (
                    <Grid item>
                        <LLMExecutionResultInformation
                            executionResult={result.executionResult}
                        >
                            <LLMExecutionResultInformation.StepRunInformation />
                            <LLMExecutionResultInformation.StepVariables />
                        </LLMExecutionResultInformation>
                    </Grid>
                )}
                <Grid
                    container
                    item
                    columnGap={1}
                    alignSelf="flex-end"
                    width="fit-content"
                >
                    <Grid item>
                        <GoToConversation
                            conversationId={result.conversation.id}
                        />
                    </Grid>
                    {result.executionResult?.transcript && (
                        <Grid item>
                            <ViewTranscript
                                transcript={result.executionResult.transcript}
                            />
                        </Grid>
                    )}
                </Grid>
            </Stack>
        </Paper>
    );
}
